<template>
    <div id="info_service_packs">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <h3>Thông tin dịch vụ</h3>
                </div>
            </div>

            <vs-divider/>

            <div class="vx-row">
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Nhóm dịch vụ</label>
                    <v-select class="w-full" v-model="servicePacks" :options="servicePacksOptions" name="nameservicePacks"
                              v-validate="'required'" :disabled="isUpdate">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('nameservicePacks') }}</span>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Mã dịch vụ</label>
                    <vs-input class="w-full" v-model="servicePacksInfo.code" name="codeServicePacks"
                              v-validate="'required'"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('codeServicePacks') }}</span>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Tên dịch vụ</label>
                    <vs-input class="w-full" v-model="servicePacksInfo.name" name="nameServicePacks"
                              v-validate="'required'"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('nameServicePacks') }}</span>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Thời gian</label>
                    <vs-input class="w-full" v-model="servicePacksInfo.time" name="time"
                              v-validate="'required'"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Đơn vị</label>
                    <vs-input class="w-full" v-model="servicePacksInfo.unit" name="unit"
                              v-validate="'required'"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('unit') }}</span>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Đơn giá</label>
                    <vs-input class="w-full" v-model="servicePacksInfo.unitPrice" name="unitPrice"
                              v-validate="'required'"
                              @input="convert($event)"></vs-input>
                </div>
                <div class="vx-col lg:w-1/2 w-full mt-4">
                    <label class="vs-input--label">Ghi chú</label>
                    <vs-textarea class="w-full" v-model="servicePacksInfo.description" name="description"/>
                </div>
            </div>

            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full text-center">
                    <label class="vs-input--label">Banner</label>
                    <div class="flex justify-center items-center" @dragover="dragover" @drop="drop">
                        <div class="card-img flex justify-center" v-if="banner.length > 0" @click="deleteBanner"
                             @mouseover="showBtnDelete = true" @mouseout="showBtnDelete = false">
                            <img id="banner" :src="banner[0].src" alt="" @load="onloadImagePreview()">
                            <div class="absolute delete" v-if="showBtnDelete" @click="deleteBanner">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="rgba(var(--vs-danger), 1)" width="32px"
                                     height="32px"
                                     viewBox="-1.7 0 20.4 20.4" class="cf-icon-svg" @click="deleteBanner">
                                    <path
                                        d="M16.417 10.283A7.917 7.917 0 1 1 8.5 2.366a7.916 7.916 0 0 1 7.917 7.917zm-6.804.01 3.032-3.033a.792.792 0 0 0-1.12-1.12L8.494 9.173 5.46 6.14a.792.792 0 0 0-1.12 1.12l3.034 3.033-3.033 3.033a.792.792 0 0 0 1.12 1.119l3.032-3.033 3.033 3.033a.792.792 0 0 0 1.12-1.12z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="card-no-img" v-else @click="selectImage">
                            <div class="flex items-center justify-center h-full">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"
                                     viewBox="0 0 24 24"
                                     fill="none">
                                    <rect width="24" height="24" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13V9ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                                          fill="#323232"/>
                                </svg>
                                <span>Thêm ảnh</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full text-center">
                    <label class="vs-input--label">Ảnh trước/sau</label>
                    <div class="flex justify-center">
                        <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                                   @before-remove="beforeRemove" @edit-image="editImage"
                                                   :data-images="imagesBeforeAndAfter">
                        </vue-upload-multiple-image>
                    </div>
                </div>
                <div class="vx-col lg:w-1/2 md:w-1/3 sm:w-1/2 w-full">
                    <div class="table_media">
                        <vs-table stripe :data="careDocument" noDataText="Không có dữ liệu" pagination max-items="5">
                            <template slot="header">
                                <div class="vx-row w-full">
                                    <h4 class="vx-col w-1/2 mb-8">
                                        Danh sách file chăm sóc
                                    </h4>
                                    <div class="vx-col w-1/2">
                                        <vs-button class="float-right" color="primary" icon-pack="feather"
                                                   icon="icon-plus"
                                                   @click="addFile">Thêm file
                                        </vs-button>
                                    </div>
                                </div>
                            </template>
                            <template slot="thead">
                                <vs-th>
                                    STT
                                </vs-th>
                                <vs-th>
                                    Tên file
                                </vs-th>
                                <vs-th>
                                    Hành động
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].stt">
                                        {{ tr.stt }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].fileName">
                                        {{ tr.fileName }}
                                    </vs-td>

                                    <vs-td>
                                        <div>
                                            <vx-tooltip text="Xóa" position="top">
                                                <feather-icon icon="TrashIcon" class="text-danger mt-4 mr-2"
                                                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                              @click="confirmDelete(tr)"/>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <vs-input class="hidden" type="file" id="uploadFile" @change="uploadFile($event)"
                              multiple></vs-input>
                </div>
                <input type="file" ref="bannerInput" accept="image/*" @change="handleImageUpload"
                       class="hidden"/>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-8 flex flex-wrap items-center justify-end">
                        <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                                   v-if="(isUpdate && isPermissionUpdateServicePacks) || (!isUpdate && isPermissionCreateServicePacks)">
                            {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/user/manage-service-packs')">
                            {{ $t('button.back') }}
                        </vs-button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {

    data() {
        return {
            servicePacksOptions: [],
            servicePacksInfo: {
                beautyServiceId: null,
                name: null,
                code: null,
                unitPrice: null,
                time: null
            },
            isUpdate: false,
            images: [],
            optionsNumber: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            imagesBeforeAndAfter: [],
            banner: [],
            showBtnDelete: false,
            careDocument: [],
            dataDelete: {},
        }
    },

    components: {
        vSelect,
        VueUploadMultipleImage,
    },

    computed: {
        servicePacks: {
            get() {
                let obj = this.servicePacksOptions.find(el => el.value == this.servicePacksInfo.beautyServiceId);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.servicePacksInfo.beautyServiceId = obj ? obj.value : null;
            }
        },

        validateForm() {
            return !this.errors.any()
        },
    },

    async created() {

        await this.getAllServicePacks()
        if (this.$route.query.id) {
            this.isUpdate = true;
            await this.findServicePacksById(this.$route.query.id);
            for (const x of this.servicePacksInfo.beforeAfterImages) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                let result = {
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: this.servicePacksInfo.fileManagers.indexOf(x) === 0,
                    file: file,
                    id: x.id,
                }
                this.imagesBeforeAndAfter.push(result);
            }
            for (const x of this.servicePacksInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.name, metadata);
                file.id = x.id;
                this.banner.push(file);

                this.banner.forEach((file) => {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        file.src = e.target.result;
                    }
                    reader.readAsDataURL(file);
                });

                setTimeout(() => {
                    let image = document.getElementById('banner');
                    image.src = this.banner[0].src;
                }, 100)
            }
            for (const x of this.servicePacksInfo.careDocuments) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.name, metadata);
                file.id = x.id;
                file.fileName = x.name;
                file.stt = this.servicePacksInfo.careDocuments.indexOf(x) + 1;
                this.careDocument.push(file);
            }
        }
    },

    methods: {

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            // this.servicePacksInfo.time = parseInt(this.servicePacksInfo.time);
            this.servicePacksInfo.unitPrice = this.servicePacksInfo.unitPrice.replaceAll(',', '');

            const formData = new FormData();
            const blob = new Blob([JSON.stringify(this.servicePacksInfo)], {type: 'application/json'});
            formData.append('dto ', blob);

            this.banner.forEach(x => {
                if (!x.id) formData.append('files', x)
            });
            this.imagesBeforeAndAfter.forEach(x => {
                if (!x.id) formData.append('beforeAfterImages', x.file)
            });
            this.careDocument.forEach(x => {
                if (!x.id) formData.append('careDocuments', x);
            });

            let url = this.isUpdate ? '/beauty-service-package/update' : '/beauty-service-package/create';

            this.$vs.loading();
            this.$crm.post(url, formData).then(() => {
                this.$vs.loading.close();
                this.$router.push('/user/manage-service-packs');
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} dịch vụ thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
            }).catch(err => {
                this.servicePacksInfo.unitPrice = this.numberWithCommas(this.servicePacksInfo.unitPrice);
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getAllServicePacks() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: null,
                }

                this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                    this.servicePacksOptions = res.data.content.map(el => {
                        return {
                            value: el.id,
                            label: el.code + '.' + el.name
                        }
                    });
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        findServicePacksById(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/beauty-service-package/find-by-id/${id}`).then(res => {
                    this.servicePacksInfo = res.data;
                    this.servicePacksInfo.unitPrice = this.numberWithCommas(this.servicePacksInfo.unitPrice);
                    this.servicePacksInfo.fileManagerDeleteIds = [];
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        uploadImageSuccess(formData, index, fileList, file) {
            this.imagesBeforeAndAfter = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.servicePacksInfo.fileManagerDeleteIds.push(this.imagesBeforeAndAfter[index].id);
            this.imagesBeforeAndAfter = fileList
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.imagesBeforeAndAfter = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        convert(e) {
            let str = e.split(' ')
                .join('')
                .replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
                .replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
                .replace(/ì|í|ị|ỉ|ĩ/g, "i")
                .replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
                .replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
                .replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
                .replace(/đ/g, "d")
                .replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A")
                .replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E")
                .replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I")
                .replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O")
                .replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U")
                .replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y")
                .replace(/Đ/g, "D")
                .replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "")
                .replace(/\u02C6|\u0306|\u031B/g, "")
                // eslint-disable-next-line no-useless-escape
                .replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ")
                .trim()
                .toLowerCase();

            if (str.match(/[a-z]/i)) {
                return this.$vs.notify({
                    text: 'Đơn giá phải là ký tự số!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.servicePacksInfo.unitPrice = this.numberWithCommas(e.replaceAll(',', ''));
        },

        isPermissionCreateServicePacks() {
            return isAPI(this, constAPI.beauty_service_pack_create);
        },

        isPermissionUpdateServicePacks() {
            return isAPI(this, constAPI.beauty_service_pack_update);
        },

        selectImage() {
            this.$refs.bannerInput.click();
        },
        handleImageUpload() {
            this.$vs.loading()
            let imageUpload = [...this.$refs.bannerInput.files];
            imageUpload.forEach((file) => {
                const reader = new FileReader();
                reader.onload = function (e) {
                    file.src = e.target.result;
                }
                reader.readAsDataURL(file);
            });

            this.banner = imageUpload;
            setTimeout(() => {
                let image = document.getElementById('banner');
                image.src = imageUpload[0].src;
            }, 100)

            // Clear the file input
            this.$refs.bannerInput.value = null;
        },
        deleteBanner() {
            this.servicePacksInfo.fileManagerDeleteIds.push(this.banner[0].id);
            this.banner = [];
        },
        uploadFile(data) {
            let file = [...data.target.files];
            this.careDocument = this.careDocument.concat(file);
            this.careDocument.forEach((q) => {
                if (!q.fileId) q.fileName = q.name;
                q.stt = this.careDocument.indexOf(q) + 1;
                return q;
            });
        },
        confirmDelete(data) {
            this.dataDelete = data;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('warningMenuCustomer.titleWarning'),
                text: 'Bạn có chắc chắn muốn xóa file này không ?',
                accept: this.deleteFile,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteFile() {
            if (this.dataDelete.id) this.servicePacksInfo.fileManagerDeleteIds.push(this.dataDelete.id);
            this.careDocument = this.careDocument.filter(t => t.stt != this.dataDelete.stt);
            this.careDocument.forEach((q) => {
                q.stt = this.careDocument.indexOf(q) + 1;
                return q;
            });
        },
        addFile() {
            document.getElementById('uploadFile').click();
        },

        onloadImagePreview() {
            this.$vs.loading.close()
        },

        dragover(e) {
            e.preventDefault()
        },
        drop(e) {
            e.preventDefault()
            this.banner = []
            this.$refs.bannerInput.files = e.dataTransfer.files
            this.handleImageUpload()
        },
    }

}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
#info_service_packs {
    .card-img {
        border-radius: 1rem;
        height: 100%;
        margin-left: 20px;
        cursor: pointer;

        img {
            width: 250px;
            height: auto;
        }

        .delete {
            height: 190px;
            display: flex;
            align-items: center;
        }

        .delete:hover {
            svg {
                fill: rgba(var(--vs-danger), 1);
            }
        }
    }

    .card-no-img {
        border: dashed 1px #cccccc;
        border-radius: 1rem;
        height: 200px;
        width: 300px;
        margin-left: 20px;
        cursor: pointer;
    }

    .card-no-img:hover {
        border: dashed 1px rgba(var(--vs-primary), 1);

        span {
            color: rgba(var(--vs-primary), 1);
        }

        svg path {
            fill: rgba(var(--vs-primary), 1);
        }
    }
}
</style>
